export const environment = {
    production: false,
    version: '1.0.2',
    apiUrls: {
        socketUrl: 'https://urban-lens.meander.one/api',
        master: 'https://urban-lens.meander.one/api',
        wondrfly: 'https://urban-lens.meander.one/api',
        frontendWondrfly: 'https://urban-lens.meander.one/api',
        adminWondrfly: 'https://urban-lens.meander.one/api',
        imageUrl: 'https://urban-lens.meander.one/',
        userImageUrl: 'https://urban-lens.meander.one/',
        programPageUrl: 'https://urban-lens.meander.one/program/activity-name',
        programUrl: 'https://urban-lens.meander.one/program-detail',
        adminApi: 'https://urban-lens.meander.one/api',
    },
    name: 'qc'
};
